import React from 'react'

const AccInvoice = () => {
  return (
    <div>AccInvoice</div>
  )
}

export default AccInvoice